var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
export var ApplicationStorageKeys;
(function (ApplicationStorageKeys) {
    ApplicationStorageKeys["MedicationsBrowserFilters"] = "Medications.MedicationsBrowserFilters";
    ApplicationStorageKeys["MedicationsSummaryFilters"] = "Medications.MedicationsSummaryFilters";
    ApplicationStorageKeys["PharmacyRequestsListFilters"] = "Medications.PharmacyRequestsListFilters";
    ApplicationStorageKeys["MedicationSettings"] = "Medications.MedicationSettings";
    ApplicationStorageKeys["StateTerritoryTermSettings"] = "Medications.StateTerritoryTermSettings";
    ApplicationStorageKeys["MedicationListFilters"] = "Medications.MedicationList.Filter";
    ApplicationStorageKeys["MedicationsSummaryTableSorting"] = "Medications.MedicationsSummaryTableSorting";
    ApplicationStorageKeys["MedicationsSummaryS8MultiReprescribe"] = "Medications.SummaryS8MultiReprescribe";
})(ApplicationStorageKeys || (ApplicationStorageKeys = {}));
export function deleteFromLocalStorage(key, keySuffix) {
    var targetKey = keySuffix ? key + "-" + keySuffix : key;
    localStorage.removeItem(targetKey);
}
export function useLocalStorage(key, defaults, keySuffix) {
    var _a = __read(useState(loadFromLocalStorage(key, defaults, keySuffix)), 2), state = _a[0], setState = _a[1];
    var updateValue = function (newValue) {
        setState(newValue);
        saveToLocalStorage(key, newValue, keySuffix);
    };
    return {
        value: state,
        updateValue: updateValue
    };
}
export function loadFromLocalStorage(key, defaults, keySuffix) {
    var targetKey = keySuffix ? key + "-" + keySuffix : key;
    var dehydratedPreferences = localStorage.getItem(targetKey);
    var storedPreferences;
    var restoredPreferences;
    if (dehydratedPreferences) {
        try {
            storedPreferences = JSON.parse(dehydratedPreferences);
            restoredPreferences = __assign({}, defaults);
        }
        catch (err) {
            console.error('Unable to parse saved settings, returning defaults');
            return defaults;
        }
        Object.entries(defaults).forEach(function (_a) {
            var _b = __read(_a, 2), defaultKey = _b[0], defaultValue = _b[1];
            if (typeof storedPreferences[defaultKey] === 'undefined') {
                restoredPreferences[defaultKey] = defaultValue;
            }
            else {
                restoredPreferences[defaultKey] = storedPreferences[defaultKey];
            }
        });
        return __assign(__assign({}, storedPreferences), restoredPreferences);
    }
    else
        return defaults;
}
export function saveToLocalStorage(key, object, keySuffix) {
    var targetKey = keySuffix ? key + "-" + keySuffix : key;
    var stringyFilters = JSON.stringify(object);
    localStorage.setItem(targetKey, stringyFilters);
}
